import type { RouteObject } from 'react-router-dom';

import { claimMap } from '../claimMap';

/**
 * 클레임.
 */
const claimRoutes: RouteObject[] = [
  {
    path: claimMap['exchange'].path,
    async lazy() {
      const { default: Page } = await import('@/app/claim/exchange/ExchangePage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: claimMap['return'].path,
    async lazy() {
      const { default: Page } = await import('@/app/claim/return/ReturnPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: claimMap['order-cancel'].path,
    async lazy() {
      const { default: Page } = await import('@/app/claim/order-cancel/OrderCancelPage');
      return {
        Component: Page,
      };
    },
  },
  // {
  //   path: claimMap['customerService'].path,
  //   async lazy() {
  //     const { default: Page } = await import('@/app/claim/customer-service/CustomerServicePage');
  //     return {
  //       Component: OwnerAuthGuardWrap(Cafe24AuthGuardWrap(Page)),
  //     };
  //   },
  // },
];

export default claimRoutes;
